import $ from 'jquery';

class SideBar {
    constructor() {
        this.navItem = $('.nav__action_link');
        this.sideBar = $('.sidebar');
        this.sideBarInner = $('.sidebar__inner');
        this.sidebarClose = $('#sidebar-close');
        this.overlay = $('.overlay');
        this.events();
    }

    events() {
        this.navItem.on('click', e => {
            const Id = $(e.currentTarget).attr('href');

            if (Id == '#sidebar') {
                e.stopPropagation();
                e.preventDefault();

                console.log('e')

                if (!this.isActiveSidebar()) {
                    this.openSidebar();
                } else {
                    this.closeSidebar();
                }

            }
        });

        //close side when click out side of sidebar;
        $('body').on('click', () => {
            this.closeSidebar();
        })

        //prevent closing when clicked on sidebar;
        this.sideBarInner.on('click', e => {
            e.stopPropagation();
        });

        //prevent close when window goes under 992px;
        this.sideBar.on('click', e => {
            if ($(window).width() < 992) {
                e.stopPropagation();
            }
        });



        //close side when click out side of sidebar;
        this.sidebarClose.on('click', () => {
            this.closeSidebar();
        })
    }

    //open sidebar
    openSidebar() {
        this.overlay.fadeIn();
        this.sideBar.addClass('sidebar--open');
    }

    //close sideBar
    closeSidebar() {
        this.overlay.fadeOut();
        this.sideBar.removeClass('sidebar--open');
    }

    //is active sidebar
    isActiveSidebar() {
        return this.sideBar.hasClass('sidebar--open');
    }
}

export default SideBar;